//ModalEditOwner
import {
  Modal,
  Form,
  Input,
  Select,
  InputNumber,
  Button,
  Space,
  Row,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { EDIT_CUSTOMER_ASSET } from "../../../API/apiUrls";
import dayjs from "dayjs";
import axios from "axios";

function ModalEditOwner({ open, close, dataeditowner, handledataNewOwner }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (dataeditowner) {
      form.setFieldsValue({
        relation: dataeditowner.relation,
        assetType: dataeditowner.assetType,
        cuscod: dataeditowner.assetCustomer?.cuscod,
        snam: dataeditowner.assetCustomer?.snam,
        fname: dataeditowner.assetCustomer?.fname,
        lname: dataeditowner.assetCustomer?.lname,
      });
    }
  }, [dataeditowner, form]);

  // console.log("dataeditowner", dataeditowner);

  const handleFinish = async (values) => {
    try {
      setLoading(true);
      const params = {
        ...dataeditowner,
        relation: values?.relation,
        assetCustomer: {
          ...dataeditowner?.assetCustomer,
          cuscod: values?.cuscod,
          snam: values?.snam,
          fname: values?.fname,
          lname: values?.lname,
          createdAt: dayjs(),
          updatedAt: dayjs(),
        },
      };

      console.log("params", params);
      const response = await axios.post(EDIT_CUSTOMER_ASSET, params, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
        },
      });
      console.log("response", response?.data);
      if (response?.data) {
        message.success("บันทึกข้อมูลเรียบร้อย");
        handledataNewOwner(params);
        handleClose();
        setLoading(false);
      } else {
        message.success("บันทึกข้อมูลไม่สำเร็จ");
        console.log("บันทึกข้อมูลไม่สำเร็จ");
        setLoading(false);
      }
    } catch (err) {
      console.log("Validation failed:", err);
      setLoading(false);
    }
  };

  const handleClose = () => {
    close(false);
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      width={400}
      footer={null}
      title="แก้ไขเจ้าของทรัพย์"
      destroyOnHidden
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{
          relation: "",
          assetType: "",
        }}
      >
        <Form.Item
          label="รหัสลูกค้า"
          name="cuscod"
          rules={[{ required: true, message: "กรุณากรอกรหัสลูกค้า" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="คำนำหน้า"
          name="snam"
          rules={[{ required: true, message: "กรุณากรอกคำนำหน้า" }]}
        >
          <Select
            style={{ height: "40px" }}
            options={[
              { label: "นาย", value: "นาย" },
              { label: "นาง", value: "นาง" },
              { label: "นางสาว", value: "นางสาว" },
            ]}
            placeholder="เลือกคำนำหน้า"
          />
        </Form.Item>
        <Form.Item
          label="ชื่อ"
          name="fname"
          rules={[{ required: true, message: "กรุณากรอกชื่อ" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="นามสกุล"
          name="lname"
          rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="ความสัมพันธ์"
          name="relation"
          rules={[{ required: true, message: "กรุณากรอกความสัมพันธ์" }]}
        >
          <Input placeholder="เช่น เพื่อน, ญาติ" />
        </Form.Item>
        <Row justify={"center"}>
          <Space>
            <Button onClick={handleClose}>ยกเลิก</Button>
            <Button type="primary" htmlType="submit">
              บันทึก
            </Button>
          </Space>
        </Row>
      </Form>
    </Modal>
  );
}

export default ModalEditOwner;
